var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingPresetList",
      "extra-items": [{
        text: _vm.bookingPreset.name,
        to: 'BookingCenterBookingList',
        params: _vm.$route.params.id
      }, '報表設定']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.selectedReportIndex === null
    },
    on: {
      "click": _vm.createNewReport
    }
  }, [_vm._m(0)]), _vm._l(_vm.reports, function (report, index) {
    return _c('li', {
      key: 'report-' + index,
      class: {
        active: _vm.selectedReportIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectReport(index);
        }
      }
    }, [_c('a', [_vm._v(_vm._s(report.title || "\u5831\u8868 ".concat(index + 1)))])]);
  })], 2)])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "mb-4 font-weight-bold"
  }, [_vm._v("自訂報表")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "報表名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入報表名稱"
    },
    model: {
      value: _vm.currentForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.currentForm, "title", $$v);
      },
      expression: "currentForm.title"
    }
  })], 1), _c('div', {
    staticClass: "report-fields"
  }, [_c('VueDraggable', {
    staticClass: "report-fields__list",
    attrs: {
      "handle": ".option-drag-handler",
      "list": _vm.currentForm.fields
    }
  }, _vm._l(_vm.currentForm.fields, function (field, fieldIndex) {
    return _c('div', {
      key: 'field-' + fieldIndex,
      staticClass: "report-fields__row",
      class: {
        'report-fields__row--last': fieldIndex === _vm.currentForm.fields.length - 1
      }
    }, [_c('span', {
      staticClass: "report-fields__column-label"
    }, [_vm._v(" 第 " + _vm._s(fieldIndex + 1) + " 欄 ")]), _c('i', {
      staticClass: "fa fa-bars option-drag-handler"
    }), _c('b-form-select', {
      staticClass: "report-fields__select",
      attrs: {
        "options": _vm.fieldOptions
      },
      model: {
        value: _vm.currentForm.fields[fieldIndex],
        callback: function callback($$v) {
          _vm.$set(_vm.currentForm.fields, fieldIndex, $$v);
        },
        expression: "currentForm.fields[fieldIndex]"
      }
    }), fieldIndex === _vm.currentForm.fields.length - 1 ? _c('b-button', {
      staticClass: "p-1 d-inline-flex align-items-center ml-2 flex-shrink-0",
      attrs: {
        "variant": "inverse-success"
      },
      on: {
        "click": _vm.addField
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]) : _vm.currentForm.fields.length > 1 ? _c('b-button', {
      staticClass: "p-1 d-inline-flex align-items-center ml-2 flex-shrink-0",
      attrs: {
        "variant": "inverse-danger"
      },
      on: {
        "click": function click($event) {
          return _vm.removeField(fieldIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")]) : _vm._e()], 1);
  }), 0)], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _vm.selectedReportIndex !== null ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v(" 刪除 ")]) : _vm._e(), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)], 1)], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', [_c('i', {
    staticClass: "mdi mdi-plus"
  }), _vm._v(" 新增報表 ")]);
}]

export { render, staticRenderFns }